const URL_PREFIX = '/app';

export default {
  URL_PREFIX,
  APPSPACE_URL: `${URL_PREFIX}/{{appId}}/{{appSpace}}`,
  CHILD_APP_ID: 'mediamanager',
};
